import { render, staticRenderFns } from "./Controlpacks.vue?vue&type=template&id=db4743c4&scoped=true&"
import script from "./Controlpacks.vue?vue&type=script&lang=js&"
export * from "./Controlpacks.vue?vue&type=script&lang=js&"
import style0 from "./Controlpacks.vue?vue&type=style&index=0&id=db4743c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4743c4",
  null
  
)

export default component.exports